"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINCheckboxInput = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var PINOption_1 = require("./PINOption");
var PINInput_1 = require("./PINInput");
var CheckSVG = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" aria-hidden=\"true\" focusable=\"false\" width=\"1em\" height=\"1em\" style=\"-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);\" preserveAspectRatio=\"xMidYMid meet\" viewBox=\"0 0 24 24\"><path d=\"M21 7L9 19l-5.5-5.5l1.41-1.41L9 16.17L19.59 5.59L21 7z\" fill=\"#ffffff\"/></svg>";
var PINCheckboxInput = /** @class */ (function (_super) {
    __extends(PINCheckboxInput, _super);
    function PINCheckboxInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: null,
            value: __spreadArrays((_this.props.value || _this.props.defaultValue || []))
        };
        _this.options = PINOption_1.retrieveOptions(_this.props.children, _this.props.options);
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter '_' implicitly has an 'any' type.
        _this.getValueOnChange = function (_, complement) {
            var value = __spreadArrays(_this.state.value);
            var isChecked = value.indexOf(complement) >= 0;
            if (isChecked) {
                value = value.filter(function (item) { return (item !== complement); });
            }
            else {
                value.push(complement);
            }
            _this.setState({ value: value });
            return value;
        };
        return _this;
    }
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
    PINCheckboxInput.prototype.componentWillReceiveProps = function (props) {
        this.options = PINOption_1.retrieveOptions(props.children, props.options);
    };
    // @ts-expect-error ts-migrate(2416) FIXME: Property 'render' in type 'PINCheckboxInput' is no... Remove this comment to see the full error message
    PINCheckboxInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, required = _a.required, hiddenRequired = _a.hiddenRequired, label = _a.label, name = _a.name, id = _a.id;
        return (React.createElement("div", { className: "pincheckboxinput " + (this.props.className ? this.props.className : "") },
            React.createElement("div", { className: "pincheckboxinput-label" },
                (required && !hiddenRequired) && "* ",
                label || ""),
            this.options.map(function (option, index) { return (React.createElement("div", { key: "pincheckboxinput" + index + option.label + option.value, className: "pincheckboxinput-option" + (_this.props.big ? " big" : "") },
                React.createElement("input", { className: "pincheckboxinput-option-input", type: "checkbox", id: (id || name) + index, name: name, value: option.value, checked: _this.state.value.indexOf(option.value) >= 0, readOnly: true }),
                React.createElement("div", { onClick: function (e) { return _this.onChange(e, option.value); }, className: "pincheckboxinput-option-check", style: {
                        backgroundImage: "url(data:image/svg+xml;base64," + btoa(CheckSVG) + ")",
                    } }),
                Boolean(option.label)
                    && React.createElement("label", { className: "pincheckboxinput-option-label", htmlFor: (id || name) + index, onClick: function (e) { return _this.onChange(e, option.value); } }, option.label))); })));
    };
    PINCheckboxInput.className = "PINCheckboxInput";
    PINCheckboxInput.propTypes = __assign(__assign({}, PINInput_1.PINInput.propTypes), { options: PropTypes.arrayOf(PropTypes.shape(PINOption_1.PINOption.propTypes)), focused: PropTypes.bool, big: PropTypes.bool });
    return PINCheckboxInput;
}(PINInput_1.PINInput));
exports.PINCheckboxInput = PINCheckboxInput;
//# sourceMappingURL=PINCheckboxInput.js.map